import { LOGO_ALT } from './literals';

interface Props {
  alt?: string;
  src: string;
}

function Logo({ alt, src }: Props): JSX.Element {
  return <img className="img-logo" alt={alt} src={src} />;
}

Logo.defaultProps = {
  alt: LOGO_ALT,
};

export { Logo };
